import { render, staticRenderFns } from "./Psicotropicos.vue?vue&type=template&id=03a33d18&scoped=true"
import script from "./Psicotropicos.vue?vue&type=script&lang=js"
export * from "./Psicotropicos.vue?vue&type=script&lang=js"
import style0 from "./Psicotropicos.vue?vue&type=style&index=0&id=03a33d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a33d18",
  null
  
)

export default component.exports